"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseErrorSchema = void 0;
const zod_1 = require("zod");
/**
 * This schema should not be used to parse most errors especially known errors.
 * It should be used to create and extend new error schemas. It acts as a pattern.
 * `code` is always required whereas `description` should be either required or
 * replaced by other more descriptive properties.
 **/
exports.BaseErrorSchema = zod_1.z.object({
    code: zod_1.z.string().min(1),
    description: zod_1.z.string().min(1).optional(),
});
